<template>
  <div class="mymsg big">
    <!-- 添加分类 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogadd"
      width="410px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <div style="font-weight: 600">
          <span style="color: red">*</span>
          <span> 分类名称 </span>
          <el-input
            v-model="add_data.category_name"
            placeholder="请输入10位以内汉字或字符"
            maxlength="10"
            style="width: 280px; margin-left: 5px"
          ></el-input>
        </div>
        <div style="font-weight: 600; margin: 20px 0">
          <span style="color: red">*</span>
          <span style="margin-right: 5px"> 是否启用 </span>
          <el-radio
            v-model="add_data.is_visible"
            :label="1"
          >启用</el-radio>
          <el-radio
            v-model="add_data.is_visible"
            :label="0"
          >停用</el-radio>
        </div>
        <div style="font-weight: 600">
          <span style="margin: 0 31px 0 10px"> 备注 </span>
          <el-input
            v-model="add_data.remark"
            placeholder="请输入20位以内汉字或字符"
            maxlength="20"
            style="width: 280px"
          ></el-input>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="dialogadd = false"
            size="medium"
          >取 消</el-button>
          <el-button
            type="primary"
            @click="addGroup"
            size="medium"
          >确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div>
              <span>分类名称</span>
              <el-input
                v-model="category_name"
                style="width: 220px; margin: 0 20px 0 10px"
                @input="search"
                clearable
              ></el-input>

              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981"
                @click="search"
                size="medium"
              >查询</el-button>
            </div>
            <el-button
              type="primary"
              @click="
                dialogadd = true;
                 add_data={category_name :'',is_visible:1,remark:''};
                title='添加分类'
              "
              :disabled="
                module_id_array[0] ? !module_id_array.includes('556') : false
              "
              icon="el-icon-plus"
            >添加分类</el-button>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                label="分类名称"
                prop="category_name"
              ></el-table-column>

              <el-table-column label="是否启用">
                <template slot-scope="scope">
                  <span v-if="scope.row.visible"> 启用 </span>
                  <span v-else> 停用 </span>
                  <el-switch
                    v-model="scope.row.visible"
                    active-color="#669961"
                    style="margin-left: 4px"
                    @change="
                      (value) => {
                        return changeStatus(value, scope.row.category_id);
                      }
                    "
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('558')
                        : false
                    "
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="editGroup(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('557')
                        : false
                    "
                  >编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      add_data: {
        category_name: '',
        remark: '',
        is_visible: 1
      },
      category_name: '',
      dialogadd: false,
      title: '添加分类'
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        category_name: this.category_name
      };
      this.axios
        .post('platform/TraditionOintment/getTraditionOintmentList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.visible = item.is_visible ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //添加分类
    addGroup() {
      if (!this.add_data.category_name) {
        this.$message.error('请输入分类名称');
        return false;
      }
      let data = this.add_data;
      let url = 'platform/TraditionOintment/saveTraditionOintmentInfo';
      if (this.title == '编辑分类') {
        url = 'platform/TraditionOintment/editTraditionOintmentInfo';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功');
          this.dialogadd = false;
          this.getList();
        }
      });
    },
    //编辑分类
    editGroup(row) {
      this.title = '编辑分类';
      this.add_data = {
        category_id: row.category_id,
        category_name: row.category_name,
        is_visible: row.is_visible,
        remark: row.remark
      };
      this.dialogadd = true;
    },

    //更改状态
    changeStatus(value, category_id) {
      let data = {
        category_id: category_id,
        is_visible: 0
      };
      let msg = '停用';
      if (value) {
        data.is_visible = 1;
        msg = '启用';
      }
      this.$confirm(`是否${msg}该分类？`, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post(
              'platform/TraditionOintment/saveTraditionOintmentStatus',
              data
            )
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    }
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.dialog {
  padding: 20px;
}
</style>

